import { useEffect, useState } from "react";

export const Icon = ({
	iconName,
	size = "Large",
	color = "currentColor",
	loading = false,
	onClick = () => {},
}) => {
	const [icon, setIcon] = useState(null);

	useEffect(() => {
		const fetchIcon = async () => {
			const response = await fetch(`/img/icons/${iconName}.svg`);

			let svgText = await response.text();

			//replacing color, leave empty to use currentColor (text color)
			svgText = svgText.replace(/fill="[^"]*"/gi, `fill="${color}"`);

			//Remove width&height, so that we can override it with the sizing we determined.
			svgText = svgText
				.replace(/<svg([^>]*?)width="[^"]*"/i, "<svg$1")
				.replace(/<svg([^>]*?)height="[^"]*"/i, "<svg$1");

			// Add accessibility attributes to the SVG
			svgText = svgText.replace(
				/<svg([^>]*?)>/i,
				`<svg$1 style="width: 100%; height: 100%;" role="img" aria-label="${iconName}">`,
			);

			setIcon(svgText);
		};

		if (iconName) {
			fetchIcon();
		}
	}, [iconName, color]);
	const sizes = {
		Small: "w-icon-size-1 h-icon-size-1",
		Medium: "w-icon-size-2 h-icon-size-2",
		Large: "w-icon-size-3 h-icon-size-3",
		// add more sizing options as needed
		XLarge: "w-icon-size-4 h-icon-size-4",
		XXLarge: "w-icon-size-5 h-icon-size-5",
		XXXLarge: "w-icon-size-6 h-icon-size-6",
		XXXXLarge: "w-icon-size-7 h-icon-size-7",
	};

	return icon ? (
		<div
			className={`${sizes[size]} flex items-center justify-center ${loading ? "animate-spin" : ""}`}
			// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
			dangerouslySetInnerHTML={{
				__html: icon,
			}}
			onClick={onClick}
			role="img"
			aria-label={iconName}
		/>
	) : (
		<img
			className={`${sizes[size]} flex items-center justify-center ${loading ? "animate-spin" : ""}`}
			src={`${import.meta.env.VITE_APP_WEBSITE_URL}/img/icons/${iconName}.svg`}
			alt={iconName}
			loading="lazy"
			onClick={onClick}
		/>
	);
};
